import {HiOutlineViewGrid, HiOutlineCog, HiOutlineQuestionMarkCircle, HiOutlineLogout } from 'react-icons/hi'
import { VscLibrary } from "react-icons/vsc";
import { GrConfigure } from "react-icons/gr";
import { FaFeather } from "react-icons/fa";




export const DASHBOARD_SIDEBAR_LINKS =[
    {
        key: 'dashboard',
        label: 'Dashboard',
        path: '/',
        icon: <HiOutlineViewGrid />
    },
    {
        key: 'configuration',
        label: 'Configuration',
        path: '/configuration',
        icon: <GrConfigure />
    }
    ]

export const DASHBOARD_SIDEBAR_BOTTOM_LINKS =[
    // {
    //     key: 'settings',
    //     label: 'Settings',
    //     path: '/settings',
    //     icon: <HiOutlineCog />
    // },
    // {
    //     key: 'support',
    //     label: 'Support',
    //     path: '/support',
    //     icon: <HiOutlineQuestionMarkCircle />
    // },
    // {
    //     key: 'signout',
    //     label: 'SignOut',
    //     path: '/signout',
    //     icon: <HiOutlineLogout />
    // },
]